module.exports = __webpack_public_path__ + "static/media/cards phnx logo.375cf13b.svg";